import { gql } from '@apollo/client'

export const ME_QUERY = gql`
  query MeQuery {
    me {
      id
      employeeId
      email
      firstName
      lastName
      nameDisplayPreference
      locale
      timezone
      country
      currentEmployeeLevel
      roles
      currencyForPayments
      avatarUrl
      skillCenterUrl
      managedBusinessUnits {
        id
        name
        displayName
        company {
          id
          name
        }
      }
      managedCompanies {
        id
      }
    }
  }
`
